export enum UnpaidBreak {
    FIFTEEN_MINUTES = '15 minutes',
    THIRTY_MINUTES = '30 minutes',
    FORTY_FIVE_MINUTES = '45 minutes',
    ONE_HOUR = '1 hour',
    TWO_HOUR = '2 hour',
    NO_BREAK = 'No break',
    EMPTY = ''
}
